<template>
  <div>
    <div class="subdivisionBox">
      <div class="subdivisionTop">
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="subdivisionTopItem"
          :class="{ 'active':isactive===index}"
          @click="handleActive(index)"
        >{{item}}</div>
      </div>
      <div id="subdivisionBar" class="subdivisionBar"></div>
    </div>
  </div>
</template>
<script>
    import echart from 'echarts';
    export default {
        name: 'SinceritySubdivisionBar',
        props: ['experience', 'quality', 'standard'],
        data () {
            return {
                navList: ['品质指数', '规范指数', '体验指数'],
                isactive: 0,
                experience1: [],
                quality1: [],
                standard1: [],
                myChartBar: {},
                barOptions: {
                    grid: {
                        left: '5%',
                        right: '5%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            show: true,
                            boundaryGap: true,
                            type: 'category',
                            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                            axisTick: {
                                show: false,
                                alignWithLabel: false
                            },
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                show: true,
                                align: 'center',
                                color: '#999'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            name: '数量（家）',
                            nameTextStyle: {
                                color: '#999',
                                fontSise:10
                            },
                            type: 'value',
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                color: '#999'
                            },
                            axisTick: {
                                show: false
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: '#F5F5F5'
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            name: '直接访问',
                            type: 'bar',
                            barWidth: '100%',
                            label: {
                                show: true,
                                position: 'top',
                                color: '#36B374'
                            },
                            itemStyle: {
                                color: ['#36B374'],
                                borderColor: '#36B374',
                                opacity: 0.4
                            },
                            data: [10, 52, 200, 334, 390, 330, 220, 120, 190, 250]
                        }
                    ]
                }
            };
        },
        mounted () {
            this.barOptions.series[0].data = this.experience
            this.myChartBar = echart.init(document.getElementById('subdivisionBar'))
            this.initBar();
        },
        watch: {
            experience (val) {
                this.experience = val
            },
            quality (val) {
                this.quality = val
                if (this.isactive === 0) {
                    this.barOptions.series[0].data = this.quality
                    this.myChartBar.setOption(this.barOptions);
                }
            },
            standard (val) {
                this.standard = val
            }

        },
        methods: {
            initBar () {
                this.myChartBar.setOption(this.barOptions);
            },
            handleActive (index) {
                this.isactive = index;
                if (index === 0) {
                    this.barOptions.series[0].data = this.quality
                } else if (index === 1) {
                    this.barOptions.series[0].data = this.standard
                } else if (index === 2) {
                    this.barOptions.series[0].data = this.experience
                }
                this.myChartBar.setOption(this.barOptions);
            }
        }
    };
</script>

<style lang="less" scoped>
.subdivisionBox {
  width: 100%;
  height: 270px;
  padding: 24px 0 10px 0;
  background: #fff;
}

.subdivisionTop {
  width: 236px;
  margin: 0 auto;
  border-radius: 2px;
}

.subdivisionTop::after {
  content: "";
  display: block;
  clear: both;
}

.subdivisionTopItem {
  width: 78px;
  height: 30px;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
  color: #36b374;
  border-top: 1px solid #36b374;
  border-bottom: 1px solid #36b374;
  float: left;
}

.subdivisionTopItem.active {
  color: #fff;
  background-color: #36b374;
}

.subdivisionTopItem:first-child {
  border-left: 1px solid #36b374;
  border-radius: 2px 0px 0px 2px;
}

.subdivisionTopItem:last-child {
  border-right: 1px solid #36b374;
  border-radius: 0px 2px 2px 0px;
}

.subdivisionTopItem:not(:last-child) {
  border-right: 1px solid #36b374;
}

.subdivisionBar {
  width: 100%;
  height: 200px;
}
</style>
